module.exports = __webpack_public_path__ + "profile.063c8237c74c82829240.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/img/profile.png
// module id = ../../../../../src/img/profile.png
// module chunks = styles